import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle, FiRefreshCw } = FiIcons;

function ErrorMessage({ error }) {
  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="bg-gradient-to-r from-red-500 to-pink-500 p-6 rounded-2xl mb-6">
          <SafeIcon icon={FiAlertTriangle} className="text-white text-6xl mx-auto" />
        </div>
        
        <h2 className="text-2xl font-bold text-gray-800 mb-4">
          Errore di Connessione
        </h2>
        
        <p className="text-gray-600 mb-6">
          Si è verificato un problema durante il caricamento dei dati:
        </p>
        
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6">
          <code className="text-red-700 text-sm break-words">
            {error}
          </code>
        </div>
        
        <button
          onClick={handleRefresh}
          className="w-full p-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3"
        >
          <SafeIcon icon={FiRefreshCw} />
          Ricarica Pagina
        </button>
      </div>
    </div>
  );
}

export default ErrorMessage;